import "./SidebarNav.scss";
import * as React from "react";

import { LoadingController } from "..";

interface SidebarNavProps {
  className?: string;
  heading?: string | JSX.Element;
  loading?: boolean;
  fixedWidth?: boolean;
}

export const SidebarNav = (props: React.PropsWithChildren<SidebarNavProps>) => {
  const title =
    typeof props.heading === "string" ?
      <h2>{props.heading}</h2>
    : <div className="custom-heading">{props.heading}</div>;
  return (
    <div
      className={`sidebar-nav-wrapper${props.fixedWidth ? " fixed-width" : ""} ${props.className}`}
      data-testid="sidebar-nav"
    >
      <div className="sidebar-nav">
        {title}
        {props.loading && <LoadingController selector=".sidebar-nav" isLoading={props.loading} />}
        {props.children && (
          <ul data-testid="sidebar-nav-list">
            {React.Children.map(props.children, (child) => (
              <li>{child}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default SidebarNav;
